export const shortenString = (string, limit) => {
  if (!string) {
    return '';
  }

  if (string.length <= limit) {
    return string;
  }

  if (string.length > limit) {
    return string.slice(0, limit - 4) + '...';
  }
};
